import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  Card,
  Grid,
  MenuItem,
  Select,
  CardContent,
  Typography,
  CardHeader,
  Menu,
  Divider,
  IconButton,
} from "@material-ui/core";
import {
  AddBox,
  MoreVert,
  AddCircle,
  Warning,
  WarningOutlined,
  WarningRounded,
} from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import Avatar from "@material-ui/core/Avatar";
import yellow from '@material-ui/core/colors/yellow';
import blueGrey from '@material-ui/core/colors/blueGrey';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },

  // avatar: {
  //   fontSize: 12,
  // },
  avatar1: {
    fontSize: 12,
  },
  yellowAvatar: {
    fontSize: 12,
    color: "#fff",
    margin: 5,
    backgroundColor: yellow[500],
  },
  blueGreyAvatar: {
    fontSize: 12,
    color: "#fff",
    margin: 5,
    backgroundColor: blueGrey[500],
  },
  card: {
    maxWidth: 300,
    margin: "auto",
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,255,0.3)"
    }
  },
 
}));

export default function MenuOpciones(props) {
  const { register, errors, defaultItem, ctlS, cerrarMenu , anchorEl, accionesFila } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState({ open: false, titulo: "" });
  const classes = useStyles();
  


  return (
    <React.Fragment>
        {accionesFila
          .filter((accion) =>
            typeof accion.enabled === "function"
              ? accion.enabled(anchorEl.row || {})
              : accion.enabled
          )
          .map((accion, index) => (
            <MenuItem
              key={"OpcionFila" + index}
              onClick={() => {
                accion.onClick(anchorEl.row);
                cerrarMenu();
              }}
            >
              {accion.label}
            </MenuItem>
          ))}      
    </React.Fragment>

    // { ctl.tareas.length > 0
    //   ? ctl.tareas.map((vst) => (
    // <Card>
    //   <CardHeader
    //     style={{ textAlign: "center" }}
    //     title={vst.titulo}
    //     action={
    //       <React.Fragment>
    //         <MoreVert></MoreVert>
    //       </React.Fragment>
    //     }
    //   />
    //   <Divider />
    //   <CardContent>
    //     <Typography>
    //       {vst.prioridad && vst.prioridad == 1 ? (
    //         <React.Fragment>
    //           <WarningRounded style={{ color: "red", width: 20, height: 20 }} />
    //         </React.Fragment>
    //       )
    //       )) : ''}
    //       {vst.descripcion}
    //     </Typography>
    //   </CardContent>
    //   <Divider />
    // </Card>
  );
}
